var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGreenLampArena(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.419,
    height: 83,
    viewBox: "0 0 80.419 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 12.361,
    y: 11.81,
    width: 56.281,
    height: 71.19,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#09d7d7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 49.597,
    y: 27.038,
    width: 30.822,
    height: 26.293,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#09d7d7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 42.977,
    y: 8.042,
    width: 29.641,
    height: 29.349,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "f"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#09d7d7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    x: 27.086,
    y: 0,
    width: 26.244,
    height: 30.789,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "h"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#09d7d7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "h"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i",
    x: 0,
    y: 27.126,
    width: 30.818,
    height: 26.243,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "j"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#09d7d7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "j"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    x: 7.998,
    y: 7.759,
    width: 29.351,
    height: 29.585,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "l"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#09d7d7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "l"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1112.464 -685.634)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 62,
    transform: "translate(1122 696)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455.852 -368.438)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 656.61, 1054.07)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.988,110.27c1.9,2.282.9,4.907-.732,5.614a5.178,5.178,0,0,0-2.465,2.363c-1.287,2.1-3.41,2.552-5.691,2.254a5.045,5.045,0,0,1-4.319-3.5.977.977,0,0,0-.515-.55c-2.992-.934-3.9-3.481-2.131-6.048a.785.785,0,0,0,.06-.159,3.65,3.65,0,0,1-.4-4.546.959.959,0,0,0-.07-.716,10.98,10.98,0,0,0-2.726-3.681,15.818,15.818,0,0,1-5.178-12.225,16.129,16.129,0,0,1,32.079-1.93,15.516,15.516,0,0,1-4.947,14.112,11.3,11.3,0,0,0-2.705,3.5.938.938,0,0,0,0,.76,3.739,3.739,0,0,1-.258,4.75M86.68,104.2c.452-.033.814-.083,1.176-.083,3.579,0,7.158.011,10.736-.012a.915.915,0,0,0,.665-.426,13.379,13.379,0,0,1,2.994-3.883,13.911,13.911,0,0,0-8.413-24.2,13.994,13.994,0,0,0-13.629,8.2A13.806,13.806,0,0,0,83,99.35a16.648,16.648,0,0,1,3.68,4.851m6.353,4.928c1.668,0,3.336.005,5,0,1.083,0,1.684-.513,1.691-1.405s-.617-1.448-1.658-1.45q-5-.011-10.009,0c-1.025,0-1.674.586-1.662,1.456.011.848.629,1.392,1.629,1.4,1.668.01,3.336,0,5,0m.014,2.28c-1.646,0-3.292-.02-4.937.014a2.3,2.3,0,0,0-1.169.32,1.256,1.256,0,0,0-.47,1.531,1.421,1.421,0,0,0,1.505,1.008q4.976,0,9.953,0c1.1,0,1.766-.554,1.759-1.45s-.654-1.414-1.782-1.42c-1.62-.008-3.239,0-4.859,0m-3.012,5.1c.419,1.312,1.518,1.9,3.4,1.841a2.683,2.683,0,0,0,2.659-1.841Z",
    transform: "translate(-52.45 -49.58)",
    fill: "#09d7d7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 656.61, 1054.07)",
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.656,170.317c-.73,0-1.461.018-2.191-.005a1.136,1.136,0,1,1-.011-2.262q2.151-.039,4.3,0c.816.013,1.3.489,1.283,1.165a1.16,1.16,0,0,1-1.272,1.1c-.7.021-1.408,0-2.112,0",
    transform: "translate(-246.62 -128.99)",
    fill: "#09d7d7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 656.61, 1054.07)",
    filter: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.72,50.908a5.859,5.859,0,0,1-.592.949q-1.494,1.544-3.035,3.042a1.2,1.2,0,0,1-1.679.145,1.116,1.116,0,0,1,.085-1.668c1.035-1.064,2.063-2.14,3.167-3.128a1.563,1.563,0,0,1,1.256-.23c.308.081.513.552.8.89",
    transform: "translate(-212.1 -29.93)",
    fill: "#09d7d7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 656.61, 1054.07)",
    filter: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.566,3.408c0,.729.016,1.459,0,2.188a1.086,1.086,0,0,1-1.145,1.193A1.074,1.074,0,0,1,168.343,5.6q-.027-2.227,0-4.454a1.109,1.109,0,1,1,2.216-.009c.025.755.006,1.511.006,2.266",
    transform: "translate(-129.24 12)",
    fill: "#09d7d7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 656.61, 1054.07)",
    filter: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.388,170.813c-.73,0-1.46.016-2.189,0a1.113,1.113,0,1,1,0-2.219q2.228-.026,4.457,0a1.109,1.109,0,1,1,0,2.216c-.755.023-1.512.005-2.267.005",
    transform: "translate(12 -129.45)",
    fill: "#09d7d7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 656.61, 1054.07)",
    filter: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.611,48.22a6.729,6.729,0,0,1,1.01.65c1,.959,1.975,1.941,2.945,2.928.585.6.635,1.177.182,1.647-.491.51-1.107.483-1.713-.114-1.024-1.007-2.068-2-3.023-3.068a1.588,1.588,0,0,1-.282-1.247c.071-.3.55-.515.882-.8",
    transform: "translate(-29.7 -28.46)",
    fill: "#09d7d7"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGreenLampArena);
export default __webpack_public_path__ + "static/media/icon-green-lamp-arena.16998cd377410c46fc36b6f44d300a5b.svg";
export { ForwardRef as ReactComponent };